/* eslint-disable no-useless-escape */
// import moment from "moment/moment";
import { EncryptStorage } from "encrypt-storage";
import { Notify } from "Component/Notify";
import moment from "moment";

//fungsi membatasi jumlah karakter yang tampil
//konversi KB ke MB
export const licenseNumber = "X7K8PMN3J2Q9Z5A8L4TPYF7B1";
const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);

export const characterLimit = (text, limitText) => {
  const truncatedText =
    text?.length > limitText ? `${text?.slice(0, limitText)}...` : text;
  return truncatedText;
};

//konversi KB ke MB
export const convertKBtoMB = (kb, numberBehindComa) => {
  return (kb / 1024).toFixed(numberBehindComa);
};

export const bytesToMB = (bytes) => (bytes / (1024 * 1024)).toFixed(2);

export const formatFileSize = (size) => {
  try {
    if (typeof size !== "number" || size < 0) throw new Error("Invalid size");
    if (size < 1024) return `${size} B`;
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    return `${(size / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  } catch {
    return "0 B";
  }
};

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Tambah 1 karena bulan dimulai dari 0
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const roundToTwoDecimals = (num) => {
  return Math.floor(num * 100);
};

//fungsi menampilkan image biner
export const displayBinaryImage = (image) => {
  const base64Format = "data:image/jpeg;base64,";
  const defaultImage = "/defaultImage.png";

  return image ? base64Format + image : defaultImage;
};

//fungsi untuk menampilkan date dari api
export const formatDisplayDate = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("D MMM YYYY");
};

export const formatDisplayDate2 = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("D-MM-YYYY");
};
export const formatTimestamp = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("DD MMM yyyy HH:mm");
};

export const formatDisplayDate3 = (data) => {
  const inputDate = data;
  const date = moment.utc(inputDate);
  return date.format("YYYY-MM-DD HH:mm:ss");
};

//fungsi untuk input date form
export const formatDateInput = (field) => {
  return moment(field).format("YYYY-MM-DD");
};

export const formatDateTimeInput = (field) => {
  return moment(field).format("YYYY-MM-DD HH:mm:ss");
};

//fungsi logout + menghapus data di local storage
export const handleLogout = () => {
  // const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  encryptStorage.clear();
  localStorage.clear();
  window.location.href = "/login";
};

// Fungsi pagination manual
export function paginate(array, pageNumber, pageSize) {
  const startIndex = pageNumber * pageSize; // Tidak ada -1, karena pageNumber dimulai dari 0
  const endIndex = startIndex + pageSize;
  return array.slice(startIndex, endIndex);
}

//fungsi untuk menghilangkan kutip
export const valueWithoutQuotes = (value) => {
  return value.replace(/['"]+/g, "");
};

export const handleArrayValue = (value) => {
  return value.replace(/[\[\]"]/g, "");
};

//fungsi untuk convert file ke base64
export const fileToBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

export const isAllDataNotNull = async (body) => {
  for (const key in body) {
    if (body[key] === null || body[key] === undefined || body[key] === "") {
      return false;
    }
  }

  return true;
};

export const base64ToFile = (base64String, filename) => {
  const arr = base64String.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const dataURItoBlob = (dataURI) => {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

export const isoStringToDateInput = (isoString) => {
  if (!isoString) return "";
  return isoString.split("T")[0];
};

export const convertToISOString = (dateValue) => {
  if (!dateValue) return "";
  const localDate = new Date(dateValue);
  return localDate.toISOString();
};

export function capitalizeFirstLetter(string) {
  if (typeof string !== "string") return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const handleError = (error) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.message || "Terjadi kesalahan";
  const auth = () => {
    Notify.error({
      title: "Unauthorized",
      description: "Silakan login ulang",
    });
    // encryptStorage.clear();
    // localStorage.clear();
    // window.location.href = "/login";
  };

  if (status === 401) {
    auth();
    return;
  }

  switch (status) {
    case 400:
      Notify.error({ title: "Bad Request", description: message });
      break;
    case 403:
      Notify.error({
        title: "Forbidden",
        description: "Anda tidak memiliki akses",
      });
      break;
    case 404:
      Notify.error({
        title: "Not Found",
        description: "Data tidak ditemukan",
      });
      break;
    case 500:
      Notify.error({
        title: "Server Error",
        description: "Terjadi kesalahan di server",
      });
      break;
    default:
      Notify.error({ title: "Error", description: "terjadi kesalahan" });
  }
  // Notify.error({
  //   title: "Gagal",
  //   description: error?.response?.data?.message,
  // });
};
export const handleErrorGlobal = (error) => {
  Notify.error({
    title: "Gagal",
    description: error,
  });
};

export const handleWarning = (message) => {
  Notify.warning({
    title: "Peringatan",
    description: message,
  });
};

export const handleSuccess = (message) => {
  Notify.success({
    title: "Berhasil",
    description: message || "Berhasil",
  });
};

export const convertToIndonesianTime = (timestamp) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const date = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const currentTimestamp = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;

  if (timestamp === currentTimestamp) {
    console.log("Timestamp cocok!");
  } else {
    // console.log(`Timestamp tidak cocok. Saat ini: ${currentTimestamp}`);
  }
  return currentTimestamp;
};

export function ubahStripKeSpasi(teks) {
  return teks?.replace(/-/g, " ");
}

const renderObject = (data, excludeKeys = [], level = 0) => {
  if (typeof data !== "object" || data === null) return null;

  const indent = { marginLeft: `${level * 20}px` };

  return Object.entries(data)
    .filter(([key]) => !excludeKeys.includes(key))
    .map(([key, value]) => {
      let parsedValue = value;

      // Coba parse jika string berbentuk objek/array
      if (
        typeof value === "string" &&
        (value.startsWith("{") || value.startsWith("["))
      ) {
        try {
          parsedValue = JSON.parse(value);
        } catch {
          parsedValue = value;
        }
      }

      // Deteksi field terkait tanggal
      const lowerKey = key.toLowerCase();
      const isDateField = [
        "timestamp",
        "date_modified",
        "created_at",
        "updated_at",
      ].some((k) => lowerKey.includes(k));

      // Format jika bernilai angka timestamp (milidetik) atau string ISO
      if (isDateField) {
        if (typeof parsedValue === "number") {
          parsedValue = moment(parsedValue).format("YYYY-MM-DD HH:mm:ss");
        } else if (typeof parsedValue === "string") {
          const m = moment(parsedValue);
          if (m.isValid()) {
            parsedValue = m.format("YYYY-MM-DD HH:mm:ss");
          }
        }
      }

      const isObject = typeof parsedValue === "object" && parsedValue !== null;

      // Format key: ganti _ dengan spasi, lalu kapital tiap kata
      const formattedKey = key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

      return (
        <div key={`${key}-${level}`} style={indent}>
          <strong>{formattedKey}:</strong>{" "}
          {isObject ? (
            <div>{renderObject(parsedValue, excludeKeys, level + 1)}</div>
          ) : (
            <span>{String(parsedValue)}</span>
          )}
        </div>
      );
    });
};

const RecursiveObjectDisplay = ({ data, excludeKeys = [] }) => {
  return <div>{renderObject(data, excludeKeys)}</div>;
};

export default RecursiveObjectDisplay;

export async function urlToBase64(imageUrl) {
  try {
    const response = await fetch(imageUrl);

    if (!response.ok) {
      throw new Error(
        `Gagal fetch gambar: ${response.status} ${response.statusText}`
      );
    }

    const contentType = response.headers.get("Content-Type");
    if (!contentType.startsWith("image/")) {
      throw new Error("URL tidak mengarah ke gambar");
    }

    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result); // base64 string
      };

      reader.onerror = (error) => {
        reject(
          new Error("Gagal membaca blob sebagai base64: " + error.message)
        );
      };

      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error(
      "Terjadi kesalahan saat konversi URL ke base64:",
      error.message
    );
    return null;
  }
}
